import type { FeatureWebModule } from '../../modules/core/index.js'
import { AdminFacilityExports, AdminWorkerSummaries } from './components/AdminSections.js'
import { HrExportCard } from './components/HrExportCard.js'
import { RosterRowPanel } from './components/RosterRowPanel.js'
import { WorkerPerformancePage } from './components/WorkerPerformancePage.js'
import { FEATURE_KEY, FEATURE_NAME } from './labels.js'
import { PERFORMANCE_HELP_TOPICS } from './help.js'

/**
 * The Performance Summaries add-on's screens (docs/plans/annual-review-plan.md
 * section 5.6): a Performance tab in each open roster row, beside Scoring,
 * to generate and open a worker's summaries, a section of the Reporting tab to export the facility's
 * for HR with its receipts, a Performance tab in the worker's own app for the
 * summaries released to them, and read-only sections in the admin area.
 * No tab of its own: the summary belongs beside the worker it is about.
 */
export const performanceReviewsWebModule: FeatureWebModule = {
  key: FEATURE_KEY,
  name: FEATURE_NAME,
  workerTab: { label: 'Performance', panel: RosterRowPanel },
  reportingSection: HrExportCard,
  workerAppTab: { label: 'Performance', page: WorkerPerformancePage },
  adminWorkerSection: AdminWorkerSummaries,
  adminFacilitySection: AdminFacilityExports,
  helpTopics: PERFORMANCE_HELP_TOPICS,
}
